import * as THREE from 'three'
import TweenLite from 'gsap/TweenLite'
import { Power3 } from 'gsap/EasePack'

import Cursor from './Cursor'
import Models from './Models'

export default class ModelsExperience {
    /**
     * Constructor
     */
    constructor() {
        this.setTime()
        this.setSizes()
        this.setCursor()
        this.setRenderer()
        this.setModels()

        this.update()
        this.resize()
    }

    /**
     * Set time
     */
    setTime() {
        this.time = {}
        this.time.start = +new Date()
        this.time.elapsed = 0
        this.time.current = this.time.start
        this.time.delta = 16
    }

    /**
     * Set cursor
     */
    setCursor() {
        this.cursor = new Cursor()
    }

    /**
     * Set resize
     */
    setSizes() {
        this.sizes = {}
        this.sizes.width = 1920
        this.sizes.height = 1080

        window.addEventListener('resize', () => {
            this.resize()
        })
    }

    /**
     * Set renderer
     */
    setRenderer() {
        // Renderer
        this.renderer = new THREE.WebGLRenderer({
            stencil: false,
            depth: true
        })
        this.renderer.setClearColor(0x000000)
        // this.renderer.sortObjects = false
    }

    setModels() {
        this.models = new Models({
            time: this.time,
            sizes: this.sizes,
            cursor: this.cursor,
            renderer: this.renderer,
            hasTexture: false
        })
    }
    
    /**
     * Set index
     */
    setIndex(_index = 0) {
        this.models.goToLevel(_index)
        
        const positions = [
            { x: 0.6 },
            { x: -0.6 },
            { x: 0.6 },
            { x: 1 }
        ]
        let position = positions[_index]
        
        if (this.sizes.width <= 770) {
            position = { x: 0.5 }
        }
        
        TweenLite.killTweensOf(this.models.models.container.position)
        TweenLite.to(this.models.models.container.position, 1, { ...position, ease: Power3.easeInOut })
    }

    /**
     * Resize
     */
    resize() {
        this.sizes.width = window.innerWidth
        this.sizes.height = window.innerHeight

        // Resize cursor
        this.cursor.resize(this.sizes.width, this.sizes.height)

        // Resize models
        this.models.resize()

        // Renderer / Composer
        this.renderer.setSize(this.sizes.width, this.sizes.height)
    }

    /**
     * Update
     */
    update() {
        this.raf = window.requestAnimationFrame(() => {
            this.update()
        })

        const time = +new Date()
        this.time.elapsed = time - this.time.start
        this.time.delta = time - this.time.current
        this.time.current = time

        if (this.time.delta > 60) {
            this.time.delta = 60
        }

        // Update grid
        this.models.update()
    }

    dispose() {
        // RAF
        window.cancelAnimationFrame(this.raf)

        // Resize
        window.removeEventListener('resize', this.resize)

        // Cursor
        this.cursor.dispose()

        // Models
        this.models.dispose()

        // Renderer
        this.renderer.dispose()
    }
}



// WEBPACK FOOTER //
// ./src/scripts/libs/experience/ModelsExperience.js